export default __webpack_public_path__ + "static/media/Mexico Tourism - Logo.513d5799.png";